import { IdCellProps } from './IdCell.types';
import { TableBodyCell } from '../../../../../MyTickets.styled';

export const IdCell = ({ id }: IdCellProps) => {
  return (
    <TableBodyCell>
      <span title={String(id)} className="ellipsis">
        {id}
      </span>
    </TableBodyCell>
  );
};
